var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAltLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 51C62 57.6274 56.1797 63 49 63C41.8203 63 36 57.6274 36 51C36 44.3726 41.8203 39 49 39C56.1797 39 62 44.3726 62 51ZM37.7853 51C37.7853 56.7173 42.8063 61.352 49 61.352C55.1937 61.352 60.2147 56.7173 60.2147 51C60.2147 45.2827 55.1937 40.648 49 40.648C42.8063 40.648 37.7853 45.2827 37.7853 51Z",
    fill: "#B5B9BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40C71 57.1208 57.1208 71 40 71C22.8792 71 9 57.1208 9 40C9 22.8792 22.8792 9 40 9C57.1208 9 71 22.8792 71 40ZM11.2214 40C11.2214 55.894 24.106 68.7786 40 68.7786C55.894 68.7786 68.7786 55.894 68.7786 40C68.7786 24.106 55.894 11.2214 40 11.2214C24.106 11.2214 11.2214 24.106 11.2214 40Z",
    fill: "#B5B9BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 60L69.5 74",
    stroke: "#B5B9BE",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 10.5C29.1667 20.6667 15.9 46.6 37.5 69",
    stroke: "#B5B9BE",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 11V42.5",
    stroke: "#B5B9BE",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 59V69.5",
    stroke: "#B5B9BE",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 11C47.3333 17.1667 54 24.5 54 40.5",
    stroke: "#B5B9BE",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46 63C45.1667 65 43.2 69.2 42 70",
    stroke: "#B5B9BE",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 18.5C25 25.1667 42.7 34.5 61.5 18.5",
    stroke: "#B5B9BE",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37 52.9999C32.1667 52.8332 21.5 53.8999 17.5 59.4999",
    stroke: "#B5B9BE",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10 39.5H69",
    stroke: "#B5B9BE",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltLogo);
export default __webpack_public_path__ + "static/media/altLogo.9cc0105738bfad7056492f2e67940e42.svg";
export { ForwardRef as ReactComponent };